import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { DateModel } from '../../_kernel/Date'

export const CancellationPolicyValidation = z.object({
  fromDate: z.instanceof(DateModel, { message: '[CancellationPolicy] fromDate is required' }),
})

export class CancellationPolicy extends Model {
  static create({ fromDate }: z.infer<typeof CancellationPolicyValidation>) {
    CancellationPolicyValidation.parse({ fromDate })
    return new CancellationPolicy(fromDate)
  }

  static fromJSON(json: ReturnType<CancellationPolicy['toJSON']>) {
    return CancellationPolicy.create({ fromDate: DateModel.create({ value: json.fromDate }) })
  }

  constructor(private readonly _fromDate: DateModel) {
    super()
  }

  get fromDate() { return this._fromDate.value } // prettier-ignore

  toJSON() {
    return { fromDate: this.fromDate }
  }

  getFromDateFormatted(locale: string) {
    return this._fromDate.getFormatted(locale)
  }
}
